// extracted by mini-css-extract-plugin
module.exports = {"textTile":"ProductListingCategoryTiles_textTile__ez3Fj"};